var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.label)?_c('label',[_vm._v(_vm._s(_vm.label))]):_vm._e(),_c('textarea',{ref:"editor",staticClass:"form-control",attrs:{"placeholder":_vm.placeholder}}),(_vm.error)?_c('div',{staticClass:"v-messages error--text"},[_vm._v(" "+_vm._s(_vm.error)+" ")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }